import { PatchOrderRequestedResponse } from '@cemex-core/cmx-api';
import { AdtCreateOrderActionTypes } from '../../actions/order-creation.action';

/**
 * Order creation state
 */
export interface OrderCreationState {
    loading: boolean;
    orderCreated: PatchOrderRequestedResponse;
}

/**
 * Initial state of order creation
 */
export const initialState: OrderCreationState = {
    loading: false,
    orderCreated: undefined,
};

/**
 * Reducer of order creation state
 * @param state State of order creation
 * @param action Actions of order creation
 * @returns {OrderCreationState}
 */
export function adtOrderCreationReducer(state = initialState, action): OrderCreationState {
    switch (action.type) {
        case AdtCreateOrderActionTypes.PATCH_ORDER_CREATION:
            return {
                ...state,
                loading: true,
            } as OrderCreationState;
        case AdtCreateOrderActionTypes.LOAD_ORDER_CREATED:
            return {
                ...state,
                loading: false,
                orderCreated: action.payload,
            } as OrderCreationState;
        case AdtCreateOrderActionTypes.RESET_ORDER:
            return {...initialState};
        default:
            return state;
    }
}
